<template>
  <div>
    <div class="animated fadeIn">
      <!-- <preloader v-if="preloader" margin="30px" /> -->
      <LoadingSkeleton
        v-if="preloader"
        :rows="2"
        type="table"
        :table="{ headItems: 6, bodyItems: 20 }"
        shape="square"
      />
      <template v-else>
        <div class="optimizer-table">
          <vue-opti-table-light
            v-if="table.fields.length > 0"
            @on-pagination="$_setPaginationValues($event,$_getKeywordsPaginated)"
            @on-search="$_setSearchValue($event)"
            @on-row-per-page-change="$_setPaginationValues($event,$_getKeywordsPaginated)"
            @on-sort="$_setPaginationValues($event,$_getKeywordsPaginated)"
            @on-column-filter="$_setColumnFilterValues($event,$_getKeywordsPaginated)"
            :name="$c_tableName"
            :server-side-pagination="true"
            :pages="pages"
            :page="page"
            class="targets-wrapper"
            :hover="true"
            :export-label="$c_exportLabel"
            :selectable="true"
            select-label="Keywords"
            :header-fields="$c_tableHeaders"
            :items="table.items"
            v-model="tableModel"
            :resized-columns="resizedColumns"
            @resize="$_handleColumnsResize($event)"
            :sort="{ key: 'cost', order: 'desc' }"
            :default-rows="defaultRows"
            :totals="table.totals"
            :save-settings="$_saveSettings"
            :export-csv-items="$_exportCsvItems"
            :column-filter-enable="true"
            :column-filter.sync="columnFilter"
            :column-filter-reset="false"
            sticky
          >
            <template slot="search">
              <!-- <vue-opti-select class="col-md-auto mb-2 mb-md-0"
                               :list="bulkActionOptions"
                               @click="$_bulkAction"
                               placeholder="<i class='fa fa-list-ul' style='color: black;'></i> &nbsp; Bulk Actions"
              /> -->
              <vue-opti-select-light
                :class="[ tableModel.selectedRows.length ? 'active-select' : '', 'optimizer-select icon-select dropdown-auto-width pr-2 col-md-auto']"
                :options="bulkActionOptions"
                :unique-key="({ value: { value } }) => value"
                label-key="content"
                button-type="static"
                button-placeholder="<i class='fa fa-ellipsis-h'></i>"
                @change="([item]) => { $_bulkAction(item.value) }"
              >
                <template #BUTTON_PLACEHOLDER>
                  <span class="button-placehoder-filter">
                    <i class="fa fa-ellipsis-h"></i>
                    <span>Actions</span>
                  </span>
                </template>
              </vue-opti-select-light>

              <vue-opti-select-light
                class="optimizer-select icon-select col-md-auto pl-md-0 pr-md-2"
                :options="keywordsFilter.options"
                unique-key="content"
                label-key="content"
                option-type="checkbox"
                :groups="[{ value: 'status', content: 'Status'}]"
                button-type="static"
                :value="keywordsFilter.model"
                @change="({ value }) => { keywordsFilter.model = value }"
                single
              >
                <template #BUTTON_PLACEHOLDER="{ options }">
                  <span class="button-placehoder-filter">
                    <i class="fa fa-filter"></i>
                    <span>Filters</span>
                    <b-badge v-show="options.length" pill variant="info">{{ options.length }}</b-badge>
                  </span>
                </template>
              </vue-opti-select-light>

              <div class="col-md-auto mb-2 mb-md-0 pl-md-0">
                <b-btn
                  class="secondary-button h-100"
                  block
                  v-clipboard="$_copyToClipboard('traffic_source_item_id')"
                  @success="$_clipboardSuccessHandler('keyword')"
                  @error="$_clipboardErrorHandler"
                >
                  <i class="fa fa-clipboard" /> Copy <i class="fa fa-info-circle info-icon" v-b-tooltip.hover.top title="Copy selected targets id's to clipboard." />
                </b-btn>
              </div>
              <div v-show="userAction.loading" class="col-md-auto" style="line-height: 2.5em">
                <i class="fa fa-spinner fa-spin" /> Processing...
              </div>
              <div v-show="ready.pagination" class="col-md-auto" style="line-height: 2.5em">
                <i class="fa fa-spinner fa-spin" /> Loading...
              </div>
            </template>
            <template slot="actions" slot-scope="props">
              <switch-button
                :checked="props.item.enabled"
                :hover-title="{ enabled: 'Disable', disabled: 'Enable' }"
                :update="(value) => $_updateStatus(props.item, value)"
              />
              <action-btn
                v-show="props.item.statusProcessing"
                :title="'Processing...'"
                icon="refresh fa-spin"
              />
            </template>
            <template slot="status" slot-scope="props">
              <span
                :class="`status-item status-item-${props.item.status}`"
                v-b-tooltip.hover.right
                :title="props.item.status"
                v-html="ui.publishers.status(props.item.status)"
              />
            </template>
            <template slot="keywords-bid" slot-scope="props" v-if="campaign.traffic_source_unique_name === 'ZeroPark' || campaign.traffic_source_unique_name === 'RtxPops'">
              <div class="d-flex">
                <b-form-fieldset class="mb-0">
                  <b-input-group prepend="$">
                    <b-form-input
                      class="input-bid"
                      :disabled="props.item.autoBid"
                      :value="props.item.autoBid ? campaign.bid : props.item.bid"
                      @input="$_switchKeywordBid(props.item, false, $event)"
                    >
                    </b-form-input>
                    <b-input-group-append>
                      <b-button v-b-tooltip.hover title="Submit" variant="secondary"
                                @click="$_updateBid(props.item)"
                                :disabled="props.item.autoBid"
                      ><i class="fa fa-paper-plane-o"></i></b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-fieldset>
                <switch-button class="ml-0 mb-0 mr-1"
                               :hover-title="{ enabled: 'Auto Bid', disabled: 'Manual Bid' }"
                               :update="(value) => $_switchKeywordBid(props.item, value)"
                               :checked="props.item.autoBid"
                />
              </div>
            </template>
          </vue-opti-table-light>
        </div>
      </template>
    </div>
    <!-- <bulk-modal
      title="Change Bid"
      placeholder="Enter New Bid"
      field-name="Bid"
      ref="bulkModal"
      :items="tableModel.selectedRows"
      :min="0.01"
      :step="0.01"
      right="<i class='fa fa-dollar'></i>"
      :max-limit-warning="maxCpcLimit"
      :handler="$_bulkUpdateBid"
    /> -->
  </div>
</template>

<script>
import tableFields from '@/helpers/fields/index';
import helperMixins from './mixins/helperMixins';
import tableMixins from '@sh/mixins/table';
// import BulkModal from '@sh/components/Utils/BulkModal';
import LoadingSkeleton from '@sh/components/Utils/Skeleton/LoadingSkeleton.vue';
import config from '../config.js';

export default {
  name: 'Keywords',
  components: { LoadingSkeleton },
  mixins: [helperMixins, tableMixins],
  data() {
    return {
      keywordsFilter: {
        model: 'all',
        options: config.statusFilter('keyword'),
      },
      bulkActionOptions: [
        { value: { value: false, fn: this.$_bulkUpdateStatus }, content: '<i class=\'fa fa-pause\'></i>&nbsp; Disable' },
        { value: { value: true, fn: this.$_bulkUpdateStatus }, content: '<i class=\'fa fa-play\'></i>&nbsp; Enable' },
      ],
    };
  },
  computed: {
    $c_tableHeaders() {
      return this.$_getFieldInfo(this.table.fields);
    },
    $c_tableName() {
      return `${this.account.type.name}KeywordsTable`;
    },
    $c_exportLabel() {
      return `${this.account.type.name}_keywords_performance_${this.dateRange.startDate}_${this.dateRange.endDate}`;
    },
  },
  watch: {
    'keywordsFilter.model': function () {
      this.tableModel.selectedRows = [];
      this.$_getKeywordsPaginated();
    },
  },
  methods: {
    async $_init() {
      /** ***************** Set Resized Columns from Local Storage **************** */
      this.resizedColumns = this.$settings.resizedColumns.getResizedColumns('keywords', this.campaign.traffic_source_unique_name);
      /** ************************************************************************* */

      try {
        await this.$_getKeywordsPaginated();
      } catch (error) {
        this.$n_failNotification({ title: error.response.data.message || 'An error occurred' });
      }
      this.debouncedGetActivityLogs = this.debounce(this.$_getKeywordsPaginated, 1000);
      this.preloader = false;
    },
    async $_switchKeywordBid(item, value, bid) {
      item.autoBid = value;
      item.bid = bid;
      const index = (this.table.items || []).findIndex((row) => row.traffic_source_item_id === item.traffic_source_item_id);
      if (index !== -1) {
        const newTableItems = this.table.items;
        newTableItems.splice(index, 1, item);
        this.table.items = newTableItems;
      }
      if (value) {
        this.$_updateBid(item, this.campaign.bid);
      }
    },
    async $_getKeywordsPaginated() {
      this.ready.pagination = true;
      const filter = {
        startDate: this.dateRange.startDate,
        endDate: this.dateRange.endDate,
        page: this.page,
        pageSize: this.limit,
        sort: this.sortType === 'asc' ? `+${this.sortField}` : `-${this.sortField}`,
      };
      if (this.search !== '') {
        filter.search = this.search;
      }
      if (this.keywordsFilter.model !== 'all') {
        filter.status = [this.keywordsFilter.model];
      }
      if (Object.keys(this.columnFilter).length) {
        filter.columnFilter = this.columnFilter;
      }
      let targets = [];
      try {
        targets = await this.$api.keywords.performance(this.campaign.campaign_id, filter);
        targets.items = targets.items.map((item) => {
          item.statusProcessing = false;
          item.traffic_source_currency = this.campaign.traffic_source_currency;
          item.bidLiveEditState = { state: 'READY' };
          item.autoBid = item.bid === 'auto';
          return item;
        });
      } catch (error) {
        this.$n_failNotification({ title: error.response.data.message || 'An error occurred' });
        this.ready.pagination = false;
      }
      if (targets.pagination.lastPage) {
        this.pages = targets.pagination.lastPage;
        this.defaultRows = targets.pagination.pageSize;
      }
      if (!targets.items.length) {
        this.page = 1;
      }
      if (Object.keys(targets).length > 0) {
        this.table.fields = [];
        this.table.fields.push(tableFields.getField('KEYWORDS', { name: 'actions' }));
        targets.fields.forEach((item) => {
          this.table.fields.push(tableFields.getField('KEYWORDS', {
            name: item.item.key,
            uniqueName: this.campaign.traffic_source_unique_name,
          }, item));
        });
        this.table.items = targets.items;
        targets.totals.totalElements = targets.pagination.total;
        this.table.totals = targets.totals;
      }
      this.preloader = false;
      this.ready.pagination = false;
      return targets;
    },
    async $_bulkUpdateStatus(value) {
      const rowsId = [];
      this.tableModel.selectedRows.forEach((row) => {
        if (row.enabled !== value) {
          rowsId.push(row.traffic_source_item_id);
          row.statusProcessing = true;
        }
      });
      if (rowsId.length > 0) {
        const task = this.userAction.task.create();
        try {
          const result = await this.$_userActionHandler({
            request: this.$api.keywords.action(this.campaign.campaign_id, rowsId, value ? 'start' : 'pause'),
          });
          if (result.success.length > 0) {
            this.table.items.forEach((row) => {
              if (result.success.indexOf(row.traffic_source_item_id) > -1) row.enabled = value;
            });
          }
        } catch (error) { /** * Do nothing ** */ }
        this.table.items.forEach((row) => {
          if (rowsId.indexOf(row.traffic_source_item_id) > -1) row.statusProcessing = false;
        });
        task.finish();
      }
    },
    async $_updateStatus(item, value) {
      item.statusProcessing = true;
      try {
        const keywordIds = JSON.stringify([item.traffic_source_item_id]);
        const result = await this.$_userActionHandler({
          request: this.$api.keyword.action(this.$route.params.id, keywordIds, value ? 'start' : 'pause'),
        });
        if (result.success.length > 0) item.enabled = value;
      } catch (error) { /** * Do nothing ** */ }
      item.statusProcessing = false;
    },
    // async $_bulkUpdateBid(value) {
    //   const rowsId = [];
    //   this.tableModel.selectedRows.forEach((row) => {
    //     if (row.enabled !== value) {
    //       rowsId.push(row.traffic_source_target_id);
    //       row.bidLiveEditState.state = 'BUSY';
    //     }
    //   });
    //   if (rowsId.length > 0) {
    //     const task = this.userAction.task.create();
    //     try {
    //       const result = await this.$_userActionHandler({
    //         request: this.$api.campaigns.changeKeywordBid(this.campaign.id, rowsId, value),
    //       });
    //       if (result.success.length > 0) {
    //         this.table.items.forEach((row) => {
    //           if (result.success.indexOf(row.traffic_source_target_id) > -1) row.cpc = parseFloat(value);
    //         });
    //       }
    //     } catch (error) { /** * Do nothing ** */ }
    //     this.table.items.forEach((row) => {
    //       if (rowsId.indexOf(row.traffic_source_target_id) > -1) row.bidLiveEditState.state = 'READY';
    //     });
    //     task.finish();
    //   }
    // },
    async $_updateBid(item, value) {
      value = value || item.bid;
      const task = this.userAction.task.create();
      try {
        await this.$api.campaigns.changeKeywordBid(this.campaign.campaign_id, item.traffic_source_item_id, parseFloat(value));
        this.$n_successNotification({ title: 'Bid successfully updated' });
        task.finish();
        return true;
      } catch (error) {
        this.$n_failNotification({ title: error.response.data.message || 'An error occurred' });
      }
      task.finish();
      return false;
    },
    async $_saveSettings(fields) {
      return this.$_saveSettingsOptions(fields, { type: this.campaign.traffic_source_unique_name, level: 'KEYWORD' });
    },
    $_exportCsvItems() {
      const filter = {
        startDate: this.dateRange.startDate,
        endDate: this.dateRange.endDate,
        page: 1,
        pageSize: this.table.totals.totalElements,
        sort: this.sortType === 'asc' ? `+${this.sortField}` : `-${this.sortField}`,
      };
      if (this.search !== '') {
        filter.search = this.search;
      }
      return this.$_exportCsv({ level: 'keywords', campaignId: this.campaign.campaign_id, filter });
    },
    $_handleColumnsResize(payload) {
      this.$settings.resizedColumns.setResizedColumns('keywords', this.campaign.traffic_source_unique_name, payload);
    },
  },
};
</script>

<style lang="scss">
.targets-wrapper {

}
</style>
